import i18n from "@/i18n";
import Api from "@/apis/api";

export default {
  namespaced: true,
  state: {
    languageList: [
      { text: "Korean", value: "ko" },
      { text: "Vietnamese", value: "vi" },
    ],
    corpsList: [],
    oralStatus: [
      { text: i18n.t("common.oralStatus.S"), value: "S" },
      { text: i18n.t("common.oralStatus.G"), value: "G" },
      { text: i18n.t("common.oralStatus.A"), value: "A" },
      { text: i18n.t("common.oralStatus.D"), value: "D" },
    ],
    joinStatus: [
      { text: i18n.t("common.joinStatus.Y"), value: "Y" },
      { text: i18n.t("common.joinStatus.N"), value: "N" },
    ],
    genderStatus: [
      { text: i18n.t("common.gender.M"), value: "M" },
      { text: i18n.t("common.gender.W"), value: "W" },
    ],
    cellRangeItems: [
      { text: i18n.t("common.cellRangeItems.ten"), value: 10 },
      { text: i18n.t("common.cellRangeItems.fifty"), value: 50 },
      { text: i18n.t("common.cellRangeItems.hundred"), value: 100 },
    ],
    userListHeaders: [
      {
        text: i18n.t("common.userListHeaders.num"),
        align: "start",
        value: "num",
      },
      {
        text: i18n.t("common.userListHeaders.authCode"),
        align: "start",
        value: "couponCode",
      },
      { text: i18n.t("common.userListHeaders.name"), value: "name" },
      { text: i18n.t("common.userListHeaders.gender"), value: "gender" },
      { text: i18n.t("common.userListHeaders.birth"), value: "birth" },
      {
        text: i18n.t("common.userListHeaders.latestDate"),
        value: "latestDate",
      },
      {
        text: i18n.t("common.userListHeaders.latestState"),
        value: "latestState",
      },
      {
        text: i18n.t("common.userListHeaders.userCreated"),
        value: "userCreated",
      },
      {
        text: i18n.t("common.userListHeaders.tools"),
        value: "tools",
        sortable: false,
      },
    ],
    adminListHeaders: [
      {
        text: i18n.t("common.adminListHeaders.num"),
        align: "start",
        value: "num",
      },
      { text: i18n.t("common.adminListHeaders.name"), value: "name" },
      { text: i18n.t("common.adminListHeaders.tel"), value: "tel" },
      { text: i18n.t("common.adminListHeaders.loginid"), value: "loginid" },
      { text: i18n.t("common.adminListHeaders.created"), value: "created" },
      {
        text: i18n.t("common.adminListHeaders.tools"),
        value: "tools",
        sortable: false,
      },
    ],
    oralStatusListHeaders: [
      {
        text: "common.oralStatusListHeaders.date",
        value: "date",
        sortable: false,
      },
      {
        text: "common.oralStatusListHeaders.soldierState",
        value: "soldierState",
        sortable: false,
      },
      {
        text: "common.oralStatusListHeaders.percent",
        value: "percent",
        sortable: false,
      },
    ],
    statisticsRankListHeaders: [
      {
        text: "common.statisticsRankListHeaders.index",
        value: "index",
        sortable: false,
      },
      {
        text: "common.statisticsRankListHeaders.name",
        value: "name",
        sortable: false,
      },
      {
        text: "common.statisticsRankListHeaders.gender",
        value: "gender",
        sortable: false,
      },
      {
        text: "common.statisticsRankListHeaders.birth",
        value: "birth",
        sortable: false,
      },
      // { text: i18n.t('common.statisticsRankListHeaders.oralConditionRank'), value: 'oralConditionRank', sortable: false },
      {
        text: "common.statisticsRankListHeaders.state",
        value: "state",
        sortable: false,
      },
      {
        text: "common.statisticsRankListHeaders.count",
        value: "count",
        sortable: false,
      },
      {
        text: "common.statisticsRankListHeaders.latestDate",
        value: "latestDate",
        sortable: false,
      },
    ],
    healthStatus: {
      S: {
        text: "common.healthStatus.S.text",
        paragraph: "common.healthStatus.S.paragraph",
        value: 4,
        color: "#337eff",
        icon: "health",
        description: "common.healthStatus.S.description",
        infoText: "common.healthStatus.S.infoText",
      },
      G: {
        text: "common.healthStatus.G.text",
        paragraph: "common.healthStatus.G.paragraph",
        value: 3,
        color: "#27c4aa",
        icon: "good",
        description: "common.healthStatus.G.description",
        infoText: "common.healthStatus.G.infoText",
      },
      A: {
        text: "common.healthStatus.A.text",
        paragraph: "common.healthStatus.A.paragraph",
        value: 2,
        color: "#fcb519",
        icon: "caution",
        description: "common.healthStatus.A.description",
        infoText: "common.healthStatus.A.infoText",
      },
      D: {
        text: "common.healthStatus.D.text",
        paragraph: "common.healthStatus.D.paragraph",
        value: 1,
        color: "#e64e81",
        icon: "warning",
        description: "common.healthStatus.D.description",
        infoText: "common.healthStatus.D.infoText",
      },
    },
  },
  mutations: {
    setCorpsList(state, corpsList) {
      state.corpsList = corpsList;
    },
  },
  actions: {
    fetchCorpsList({ commit }) {
      Api.getCorps().then((res) => {
        if (res && res.data.rt === 200) {
          commit("setCorpsList", res.data.corpsList);
        } else {
          alert(`${i18n.t("message.error.serverError")} ${res.data.rt}`);
        }
      });
    },
  },
};
